import React from 'react'

const LinkItem = ({ item }) => {
    return (
        <li className={item.active && "active"}>
            <a href={`#${item.link}`}>
                <span className={`icon ${item.icon}`}></span>
                <span className="link">{item.name}</span>
            </a>
        </li>
    )
}

export default LinkItem